import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Link, Text, Box } from '@nerdwallet/currency';

import Expandable from './brand-header-expandable';

import './brand-header-section.less';

function processUrl(sectionUrl, sectionName, pageSection) {
  if (sectionName === pageSection) {
    const urlAnchor = sectionUrl.split('#').pop();
    return `#${urlAnchor}`;
  }
  return sectionUrl;
}

const BrandHeaderSection = ({
  name,
  url,
  subsections,
  pageSection,
  isNavOpen,
  setIsNavOpen,
}) => {
  const processedUrlValue = processUrl(url, name, `${pageSection}`);

  const returnNav = (
    <li className="brand-header__section">
      <Link href={processedUrlValue} className="brand-header__section--link">
        {name && (
          <Box className="brand-header__section--name">
            <Text>{name}</Text>
          </Box>
        )}
      </Link>
    </li>
  );

  const subnavSection = _.map(subsections, (subsection) => {
    const processedSubUrlValue = processUrl(
      subsection.url,
      name,
      `${pageSection}`
    );

    return (
      <li className="brand-header__subnav--cont">
        <Link
          href={processedSubUrlValue}
          className="brand-header__subnav--link"
          isNavOpen={isNavOpen}
          onClick={() => setIsNavOpen(!isNavOpen)}
        >
          {subsection.name && (
            <Box className="brand-header__subnav--name">
              <Text size="small">{subsection.name}</Text>
            </Box>
          )}
        </Link>
      </li>
    );
  });

  const processedSubnavSection = <ul>{subnavSection}</ul>;

  const expandableContent = {
    title: `${name}`,
    copy: [processedSubnavSection],
  };

  const returnSubnav = (
    <Expandable {...expandableContent} id="brand-header__subnav" />
  );
  return subsections !== null ? returnSubnav : <ul>{returnNav}</ul>;
};

BrandHeaderSection.propTypes = {
  pageSection: PropTypes.string,
  isNavOpen: PropTypes.bool,
  name: PropTypes.string,
  url: PropTypes.string,
  setIsNavOpen: PropTypes.func,
  subsections: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      url: PropTypes.string,
    })
  ),
};

BrandHeaderSection.defaultProps = {
  pageSection: '',
  name: '',
  url: '',
  subsections: null,
};

BrandHeaderSection.displayName = 'BrandHeaderSection';

export default BrandHeaderSection;
